



























































import { defineComponent } from '@vue/composition-api';
import UITextInput from './UITextInput.vue'

export default defineComponent({
  components: { UITextInput },
  $_veeValidate: {
    value() {
      return this.value;
    },
    name() {
      return this.name;
    }
  },
  props: {
    value: {
      type:[String, Number],
      default:''
    },
    label: {
      type:String
    },
    id: {
      type:String,
    },
    placeholder: {
      type:String,
      default:''
    },
    disabled: {
      type: [Boolean, String],
      default: false
    },
    name: {
      type:String,
      default:''
    },
    type: {
      type:[String, Number],
      default:'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    description:{
      type: String,
      default: ''
    },
    min: {
      type: [Number, String]
    },
    autocomplete: {
      type: String,
      default: ''
    },
    readonly: {
      type: [Boolean, String]
    },
    maxlength: {
      type: String,
      default: ''
    },
    ignoreLastPass:{
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
    },
    postAddOn: {
      type: String,
      default: ''
    },
    preAddOn: {
      type: String,
      default: ''
    },
    disableArrow: {
      type: Boolean,
      default: false
    },
    adjustAddOns: {
      type: Boolean,
      default: false
    }
  }
})
